



















import { Component,Vue,Prop } from 'vue-property-decorator';
@Component({
  name: 'bmsUpdateReminder',
})
export default class extends Vue {
  @Prop() releasContent!: any;
  @Prop() title!: any;
  public isShow:boolean=false
  // 关闭
  public close(){
    this.$emit('releaseClose')
    this.isShow=false;
  }
}
